import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {Constants} from '../../../shared/config/constants.config';
import {ProfilesComponent} from '../profiles/profiles.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService} from '../../../shared/services/master.service';
import {NotificationsService} from '../../../shared/services/notification.service';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';
import {ActivatedRoute} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import * as moment from 'moment';

@Component({
    selector: 'app-profiles-send-login-modal',
    templateUrl: './profiles-send-login.component.html',
    styleUrls: ['./profiles-send-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilesSendLoginModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('inputFile') myInputVariable: ElementRef;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    profilesComponent: ProfilesComponent;
    profile: UserProfileViewModel;

    files = [];

    loginForm: FormGroup = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(5)])
    });

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly masterService: MasterService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly notificationService: NotificationsService,
        private readonly route: ActivatedRoute,
    ) {
    }

    handleFileInput($event: Event) {
        // @ts-ignore
        for (var i = 0; i < $event.target.files.length; i++) {
            // @ts-ignore
            this.files.push($event.target.files.item(i));
        }
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {
        const interval = setInterval(() => {
            if (this.profile) {
                clearInterval(interval);

                this.changeDetectorRef.markForCheck();

                setTimeout(() => {
                    // @ts-ignore
                    CKEDITOR.replace('editor1', {
                        height: 250,
                        removeButtons: 'PasteFromWord'
                    });
                }, 200);
            }
        }, 100);
    }

    onClose() {
        this.bsModalRef.hide();
    }

    onCreate() {
        const password: string = this.loginForm.controls['password'].value;

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        // @ts-ignore
        this.masterService.sendLoginInfo(this.profile.email, password, CKEDITOR.instances.editor1.getData(), this.files)
            .subscribe(
                () => {
                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                    this.myInputVariable.nativeElement.value = '';
                    this.files = [];

                    this.profilesComponent.email_sent_info[this.profile.id] = moment().format('DD.MM.YYYY');
                    this.profilesComponent.changeDetectorRef.markForCheck();

                    this.onClose();
                },
                (err: HttpErrorResponse) => {
                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                    this.myInputVariable.nativeElement.value = '';
                    this.files = [];

                    if (err.error === 'validator') {
                        this.notificationService.error('Моля, въведете всички полета!');
                    }
                }
            );
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

}
